/**
 * Schema.org Article JSON-LD builder (SSoT).
 *
 * Output key order: '@context', '@type', then the given fields.
 * Input is not mutated. No domain hardcoded.
 *
 * @module shared/schema/articleSchema
 */

export type ArticleTip = 'Article' | 'TechArticle' | 'BlogPosting' | 'NewsArticle';

export function buildArticleSchema(fields: Record<string, unknown>, tip: ArticleTip = 'Article') {
  return { '@context': 'https://schema.org', '@type': tip, ...fields };
}
